// extracted by mini-css-extract-plugin
export default {"tooltip":"zT-z","arrow":"AT-z"};